<template>
<svg :width="width" :height="height" viewBox="0 0 36 28" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M0 4C0 2.8954 0.89543 2 2 2H14.3944C14.7893 2 15.1753 1.88312 15.5038 1.6641L17.4962 0.3359C17.8247 0.11688 18.2107 0 18.6056 0H34C35.1046 0 36 0.89543 36 2V24C36 25.1046 35.1046 26 34 26H21.6056C21.2107 26 20.8247 26.1169 20.4962 26.3359L18.5038 27.6641C18.1753 27.8831 17.7893 28 17.3944 28H2C0.89543 28 0 27.1046 0 26V4Z" />
<path d="M32 12H23.4444L18 16L12.5556 12H4" stroke="white" stroke-:width="2" stroke-linecap="round"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 36 },
        height: { type: [Number, String], default: 28 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
